import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type LearningSummaryCardProps = {
  overallMasteryPercent: number;
  streakDays: number;
  masteredWrongCount: number;
  totalPracticeCount: number;
};

export function LearningSummaryCard({
  overallMasteryPercent,
  streakDays,
  masteredWrongCount,
  totalPracticeCount,
}: LearningSummaryCardProps) {
  return (
    <AppCard style={styles.card}>
      <View style={styles.primaryMetric}>
        <AppText variant="caption" tone="muted">
          综合掌握度
        </AppText>
        <AppText variant="metric" weight="bold" tone="primary">
          {overallMasteryPercent}%
        </AppText>
      </View>

      <View style={styles.metricRow}>
        <MetricItem label="连续学习" value={`${streakDays} 天`} />
        <MetricItem label="已攻克错题" value={`${masteredWrongCount} 道`} />
        <MetricItem label="累计练习" value={`${totalPracticeCount} 次`} />
      </View>
    </AppCard>
  );
}

function MetricItem({ label, value }: { label: string; value: string }) {
  return (
    <View style={styles.metricItem}>
      <AppText variant="body" weight="bold">
        {value}
      </AppText>
      <AppText variant="caption" tone="muted">
        {label}
      </AppText>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.lg,
  },
  primaryMetric: {
    gap: tokens.spacing.xs,
  },
  metricRow: {
    flexDirection: 'row',
    gap: tokens.spacing.md,
  },
  metricItem: {
    flex: 1,
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.colors.surfaceMuted,
    padding: tokens.spacing.md,
    gap: tokens.spacing.xs,
  },
});
